import { ExpandOptions } from "@repo/apis/bag";
import { BagSdkConfig } from "../sdk";
import type { BagState } from "./state.types";

export type SdkMethodContext = BagSdkConfig & {
  xSiteOrigin?: string;
  state: {
    getBagSessionToken: () => string | null;
    setBagSessionToken: (token: string) => void;
    getBag: () => BagState;
    setBag: (newBag: BagState) => void;
    getBagExpansions: () => ExpandOptions;
    setBagExpansions: (newExpansions: ExpandOptions) => void;
  };
};

export type BagSdkMethod<T> = (context: SdkMethodContext) => T;

export function initialiseMethod<T>(
  context: SdkMethodContext,
  method: BagSdkMethod<T>,
): T {
  return method(context);
}
